import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import {
  ColumnsPanelTrigger,
  GridToolbarFilterButton,
  QuickFilter,
  QuickFilterClear,
  QuickFilterControl,
  Toolbar,
  ToolbarPropsOverrides,
} from '@mui/x-data-grid';
import {
  InputAdornment,
  TextField,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import { GridToolbarProps } from '@mui/x-data-grid/internals';
import ListIcon from '@material-ui/icons/ViewList';
import SearchIcon from '@material-ui/icons/Search';
import CancelIcon from '@material-ui/icons/Cancel';
import { DEBOUNCE_TIME } from '../constants';

const SortButton = styled(IconButton)({
  padding: 0,
});

const StyledTextField = styled(TextField)({
  '& > div': {
    minWidth: 350,
    borderRadius: '32px',
  },
  '& input': {
    fontSize: 14,
  },
});

export const UsersToolbar = ({
  title,
  create,
}: {
  title?: string;
  create: 'user' | 'organization';
} & GridToolbarProps &
  ToolbarPropsOverrides) => {
  return (
    <Toolbar>
      <Box
        sx={{
          width: '100%',
          p: 2,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6">{title}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gridGap: 16 }}>
          <QuickFilter debounceMs={DEBOUNCE_TIME}>
            <QuickFilterControl
              render={({ ref, ...other }) => {
                const { color, value, ...rest } = other;
                return (
                  <StyledTextField
                    inputRef={ref}
                    aria-label="Search"
                    placeholder={`Search ${
                      create === 'user' ? 'Users' : 'Teams'
                    }`}
                    size="small"
                    variant="outlined"
                    value={value}
                    name="search"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                      endAdornment: value ? (
                        <InputAdornment position="end">
                          <QuickFilterClear
                            edge="end"
                            size="small"
                            aria-label="Clear search"
                          >
                            <CancelIcon fontSize="small" />
                          </QuickFilterClear>
                        </InputAdornment>
                      ) : null,
                    }}
                    {...rest}
                  />
                );
              }}
            />
            <QuickFilterClear />
          </QuickFilter>
          <Tooltip title="Columns">
            <ColumnsPanelTrigger
              render={
                <SortButton color="primary">
                  <ListIcon />
                </SortButton>
              }
            />
          </Tooltip>
          <GridToolbarFilterButton />
        </Box>
      </Box>
    </Toolbar>
  );
};
